import { useFeatureFlags } from '../contexts/FeatureFlagsContext';

export const useFeatureFlag = (flagName) => {
  const { isFeatureEnabled, loading, error } = useFeatureFlags();
  
  return {
    isEnabled: isFeatureEnabled(flagName),
    loading,
    error,
  };
};

export const useSignUpFeature = () => {
  const { isSignUpEnabled, loading, error } = useFeatureFlags();
  
  return {
    isSignUpEnabled: isSignUpEnabled(),
    loading,
    error,
  };
};

export const useMfaFeature = () => {
  const { isMfaAvailable, loading, error } = useFeatureFlags();
  
  return {
    isMfaAvailable: isMfaAvailable(),
    loading,
    error,
  };
};
